// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"233":"be9c7815","281":"c980f5bc","326":"f9672195","333":"4a109378","841":"fd12cc3e"}[chunkId] + ".chunk.js";
};